import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const snackbarConfig: MatSnackBarConfig = {
    duration: 900, verticalPosition: 'top'
  }